import React from 'react'

import { ListRow } from './ListRow'
import { Table } from '@ztechapps/webui.data-tools'
import { ListHeader } from './ListHeader'
import { BillToCustomer } from '../BillToCustomer'
import { CarrierTabs } from '../CarrierTabs'
import { useCheckoutContext } from '../../../index'

export const TableLayout = () => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions
  const [showLoadingOverlay] = context.showLoadingOverlay

  return (
    <React.Fragment>
      <BillToCustomer />
      <CarrierTabs>
        {(carrierRates, onSelect) => (
          <Table
            dataArray={carrierRates}
            row={ListRow}
            head={<ListHeader />}
            currentItem={shippingOptions?.carrierRate}
            selectable={true}
            onSelect={(item) => {
              if (!showLoadingOverlay) {
                onSelect(item)
              }
            }}
            className={'table-sm'}
          />
        )}
      </CarrierTabs>
    </React.Fragment>
  )
}
